import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// Super-admin sets a new password for one employee. Returns { password }. The
// parent calls MembershipV2Service.adminResetPassword (hashes it server-side)
// and is responsible for showing the plaintext password back to the admin
// once, since it can't be recovered afterwards.
@Component({
  selector: 'v2-reset-password-dialog',
  template: `
  <h2 mat-dialog-title>Reset password — {{ data.name }}</h2>
  <mat-dialog-content class="v2-dialog">
    <p class="v2-reset-hint">Set a new password for {{ data.email }}. Share it with them directly — it can't be looked up again afterwards.</p>
    <mat-form-field appearance="outline" class="full">
      <mat-label>New password</mat-label>
      <input matInput [type]="show ? 'text' : 'password'" [(ngModel)]="password" minlength="6">
      <button mat-icon-button matSuffix (click)="show = !show" type="button">
        <mat-icon>{{ show ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    </mat-form-field>
    <button mat-stroked-button type="button" (click)="generate()">Generate</button>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="ref.close()">Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!(password && password.length >= 6)" (click)="save()">Reset password</button>
  </mat-dialog-actions>
  `,
  styles: [`
    .v2-reset-hint { font-size: 13px; color: #666; margin: 4px 0 12px; }
    .full { width: 100%; }
  `]
})
export class ResetPasswordDialogComponent {
  password = '';
  show = true;

  constructor(
    public ref: MatDialogRef<ResetPasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  generate() {
    // 10 random chars from an unambiguous alphabet — easy to read aloud/type.
    const alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';
    let out = '';
    for (let i = 0; i < 10; i++) {
      out += alphabet[Math.floor(Math.random() * alphabet.length)];
    }
    this.password = out;
    this.show = true;
  }

  save() {
    if (!this.password || this.password.length < 6) { return; }
    this.ref.close({ password: this.password });
  }
}
